import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { keys } from "./keys";

type UpdateCommand = Database['public']['Tables']['topics']['Update'];

async function updateTopic(id: string, command: UpdateCommand) {
  const { error } = await apiClient
    .from('topics')
    .update(command)
    .eq('id', id);

  if (error) {
    throw error;
  }
}

export function useUpdateTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, command }: { id: string; command: UpdateCommand }) =>
      updateTopic(id, command),
    onSuccess: (_data, { id }) => {
      enqueueSnackbar('Sujet mis à jour.', 'success');
      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(false) });
      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(true) });
      queryClient.invalidateQueries({ queryKey: keys.topicListPagedAll() });
      queryClient.invalidateQueries({ queryKey: keys.topic(id) });
    }
  });
}
